import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

//* компонент swiper */
export function SwiperGallery({ images }) {
  return (
    <div className='swiper-container'>
      <button className='myPrev'>
        <svg
          width='25'
          height='35'
          viewBox='0 0 25 35'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M15 35V30H10V25H5V20H0V15H5V10H10V5H15V0H25V5H20V10H15V15H10V20H15V25H20V30H25V35H15Z'
            fill='white'
          />
        </svg>
      </button>
      <Swiper
        navigation={{
          nextEl: '.myNext',
          prevEl: '.myPrev',
        }}
        modules={[Navigation]}
        className='mySwiper'
        autoplay={{ delay: 3000 }}
        spaceBetween={109}
      >
        {images.map((imgSrc, index) => (
          <SwiperSlide key={index}>
            <img src={imgSrc.src} alt={imgSrc.alt} />
          </SwiperSlide>
        ))}
      </Swiper>
      <button className='myNext'>
        <svg
          width='25'
          height='35'
          viewBox='0 0 25 35'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M0 35V30H5V25H10V20H15V15H10V10H5V5H0V0H10V5H15V10H20V15H25V20H20V25H15V30H10V35H0Z'
            fill='white'
          />
        </svg>
      </button>
    </div>
  );
}